import { createStore } from 'vuex'
import * as getters from './getters'
import actions from './actions'
import mutations from './mutations'

const state = {
  authenticated: false,
  authenticated_user: null,
  selected_company: null,
  selected_order_of_service: null,
  selected_control_panel: null,
  selected_standard: null,
  company_dropdown: {
    has_more: true,
    companies: [],
    page: 1,
    loading: true,
  },
  order_of_service_dropdown: {
    has_more: true,
    orders_of_service: [],
    page: 1,
    loading: true,
  },
}

export default createStore({
  state,
  getters,
  actions,
  mutations,
})
